import PropTypes from "prop-types";
import React, { forwardRef, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Button from "./Button";
const ImageInput = forwardRef(
  (
    {
      defaultImage,
      file,
      setfile,
      uploadImg,
      label,
      text,
      orange,
      className,
      id,
      placeholder,
      multiple = false,
      accept,
      ...rest
    },
    ref
  ) => {
    const [imagePreviewUrl, setstateimagePreviewUrl] = useState("");
    useEffect(() => {
      if (file) {
        let reader = new FileReader();
        reader.onloadend = () => {
          setstateimagePreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
      }
    }, []);

    const handleImageChange = e => {
      e.preventDefault();
      let file = e.target.files[0];
     
        setfile(e.target.files[0])
    

      
    };
    // const onCropComplete = (crop) => {
    //   makeClientCrop(crop);
    // };
    // const makeClientCrop = (crop) => {
    //   if (imageRef && crop.width && crop.height) {
    //     const croppedImageUrl = getCroppedImg(
    //      imageRef,
    //       crop,
    //       "newFile.jpeg"
    //     );
    //     this.setState({ croppedImageUrl });
    //   }
    // };
    return (
      <div
        className={`ImageInput  relative ${className} ${orange
          ? "ImageInput--orange"
          : ""}`}
      
      >
        <div className="ImageInput--cover">
           <label className="ImageInupt--label">
          {label}
        </label>
        </div>
        <div className="ImageInput--uploadcoverbox">
          <input
            type="file"
            className="ImageInput__input "
            id={id ? id : "image__cover--perview"}
            onInput={handleImageChange}
            onFocus={e => (e.target.placeholder = "")}
            ref={ref}
            accept={accept}
            multiple={multiple}
            // defaultValue={convertToFile()}
            {...rest}
          />
          <div>
            {
              file ? file.name : placeholder
            }
          </div>
          <label
            className="ImageInput__label"
            htmlFor={id ? id : "image__cover--perview"}
          >
          
            <div className='button button__primary' >
              {text}
            </div>
          </label>
        </div>
      </div>
    );
  }
);

ImageInput.propTypes = {
  defaultImage: PropTypes.string,
  register: PropTypes.any
};



export default ImageInput